import { Article } from "./article.js";
import { Util } from "./util.js";
import { wishlist } from "@otto-ec/nexus-registry/wishlist";

const util = new Util();

export class BaseCombo {
	constructor(dom) {
		this.dom = dom;
		this._initializeArticleDoms();
		this.articles = [];
		this.id = util.readFromDataAttribute(dom, "combo_id");
		this.source = util.readFromDataAttribute(dom, "combo_src");
		this.presentation = util.readFromDataAttribute(dom, "combo_pres");
		this.articleCount = util.readFromDataAttribute(dom, "article_count");
		this.topicId = util.readFromDataAttribute(dom, "combo_topic_id");
		this._articleNumberFromADS = util.readFromDataAttribute(dom, "article_number_from_ads");
		this.comboType = util.readFromDataAttribute(dom, "combo_type");
		this._pageType = util.readFromDataAttribute(dom, "page_type");

		this._initializeArticles();
	}

	_initializeArticleDoms() {
		throw new Error("_initializeArticleDoms must be implemented by subclasses");
	}

	_initializeArticles() {
		const isArticleInTopicPage = this._pageType === "TOPIC";

		for (const articleDom of this.articleDoms) {
			const comboInfoForArticle = { comboType: this.comboType };
			this.articles.push(new Article(articleDom, wishlist, comboInfoForArticle, isArticleInTopicPage));
		}
	}

	addWishlistButtonClickHandler() {
		this.articles.forEach(article => article.addClickHandlerForWishlistBtn());
	}

	isComingFromArticleDetailPage() {
		return (this._articleNumberFromADS || "").length > 0;
	}

	/*      */
	getDom() {
		return this.dom;
	}

	getId() {
		return this.id;
	}

	getArticles() {
		return this.articles;
	}

	getArticleCount() {
		return this.articleCount;
	}

	getSource() {
		return this.source;
	}

	getPresentation() {
		return this.presentation;
	}

	getTopicId() {
		return this.topicId;
	}

	getComboType() {
		return this.comboType;
	}

	getArticleNumberFromADS() {
		return this._articleNumberFromADS;
	}

	get pageType() {
		return this._pageType;
	}
}
